import { Injectable } from '@angular/core';
import { SharedService } from '../../shared/service/shared.service';
import { environment } from '../../../../environments/environment';

@Injectable()
export class CommonService {
	// Define valiables
	SITE_API_URL: any = '';
	data: any = {};

	// Define constructor
	constructor(public sharedService: SharedService) {
		this.SITE_API_URL = environment.API_URL;
	}

	// Function to get testimonial details
	getTestimonial(): any {
		const methodName  				    = 'get_testimonial_details';
		const methodUrl 				    = environment.API_URL + methodName;
        this.data                           = {};
		return this.sharedService.getPost(methodUrl, this.data);
	}

	// This function is used for get the home page block data.
	getFeatureBlocks(): any {
		const methodName					= 'home_page_block';
		const methodUrl						= environment.API_URL + methodName;
        this.data                           = {};
		this.data.data						= {};
		this.data.data.block_slug			= ['feature-the-best'];
		return this.sharedService.getPost(methodUrl, this.data);
	}

	// This function is used to get featured company.
	getLogo(): any {
		const methodName					= 'get_featured_company';
		const methodUrl						= environment.API_URL + methodName;
		this.data							= {};
		return this.sharedService.getPost(methodUrl, this.data);
	}

	// This function is used to get notification list.
	getNotifications = (formData : any): any => {
		const methodName					= 'get_notification_list';
		const methodUrl						= environment.API_URL + methodName;
		this.data							= formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}
}
